<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('appreciation.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('appreciation.pageTitle'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper class="ts-flex ts-items-center ts-justify-between">
        <ts-button color="info" outline @click="addNew">
          {{ $t('add_new') }}
        </ts-button>
        <div class="ts-flex ts-justify-end ts-space-x-2">
          <label class="mt-2 mr-2">{{
            $t('appreciation.certificateType')
          }}</label>
          <select
            class="form-control"
            style="width: 200px"
            v-model="cert_type_id"
          >
            <option :value="null">
              {{ $t('all') }}
            </option>
            <option
              v-for="(s, index) in certificate_types"
              :key="index"
              :value="s.cert_type_id"
            >
              {{ s.cert_type }}
            </option>
          </select>
          <a-input
            v-model="search"
            v-tooltip="$t('search')"
            :placeholder="$t('search')"
            style="width: 250px"
            class="inline-block"
          />
          <ts-button
            outline
            v-tooltip="$t('filter')"
            @click.prevent="visible = true"
          >
            <i class="fa fa-filter"></i>
          </ts-button>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'request_date'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-nowrap">
              {{ record.branch ? record.branch.branch_name_en : '' }}
            </td>
            <td class="ts-text-center ts-whitespace-nowrap">
              {{ record.certificate_number }}
            </td>
            <td
              class="ts-whitespace-nowrap"
              v-if="record.cert_type_id != 18 && record.cert_type_id != 21"
            >
              {{
                record.cert_type_id == 9
                  ? record.teacher
                    ? record.teacher.full_name_en
                    : null
                  : record.cert_type_id == 10
                  ? record.staff
                    ? record.staff.name_en
                    : null
                  : record.student
                  ? record.student.full_name_en
                  : null
              }}
            </td>
            <td class="ts-whitespace-nowrap" v-if="record.cert_type_id == 18">
              <template v-if="record.details && record.details.length">
                <span v-for="(detail, index) in record.details" :key="index">
                  {{ detail.student ? detail.student.full_name_en : '' }} <br />
                </span>
              </template>
              <template v-else-if="record.student">
                {{ record.student.full_name_en }}
              </template>
            </td>
            <td class="ts-whitespace-nowrap" v-if="record.cert_type_id == 21">
              <template v-if="record.student_top_details && record.student_top_details.length">
                <span
                  v-for="(
                    student_top_detail, index
                  ) in record.student_top_details"
                  :key="index"
                >
                  {{ student_top_detail.student ? student_top_detail.student.full_name_en : '' }} <br />
                </span>
              </template>
              <template v-else-if="record.student">
                {{ record.student.full_name_en }}
              </template>
            </td>
            <td
              class="ts-whitespace-nowrap ts-text-center"
              v-if="record.cert_type_id != 18 && record.cert_type_id != 21"
            >
              {{
                record.cert_type_id == 9
                  ? record.teacher
                    ? record.teacher.sex
                    : null
                  : record.cert_type_id == 10
                  ? record.staff
                    ? record.staff.sex
                    : null
                  : record.student
                  ? record.student.gender
                  : ''
              }}
            </td>
            <td
              class="ts-whitespace-nowrap ts-text-center"
              v-if="record.cert_type_id == 18"
            >
              <template v-if="record.details && record.details.length">
                <span v-for="(detail, index) in record.details" :key="index">
                  {{ detail.student ? detail.student.gender : '' }} <br />
                </span>
              </template>
              <template v-else-if="record.student">
                {{ record.student.gender }}
              </template>
            </td>
            <td
              class="ts-whitespace-nowrap ts-text-center"
              v-if="record.cert_type_id == 21"
            >
              <template v-if="record.student_top_details && record.student_top_details.length">
                <span
                  v-for="(
                    student_top_detail, index
                  ) in record.student_top_details"
                  :key="index"
                >
                  {{ student_top_detail.student ? student_top_detail.student.gender : '' }} <br />
                </span>
              </template>
              <template v-else-if="record.student">
                {{ record.student.gender }}
              </template>
            </td>
            <td
              class="ts-text-right ts-whitespace-nowrap"
              v-if="record.cert_type_id != 18 && record.cert_type_id != 21"
            >
              {{
                record.cert_type_id == 9
                  ? record.teacher
                    ? record.teacher.phone
                    : null
                  : record.cert_type_id == 10
                  ? record.staff
                    ? record.staff.phone
                    : null
                  : record.student
                  ? record.student.phone
                  : ''
              }}
            </td>
            <td
              class="ts-whitespace-nowrap ts-text-center"
              v-if="record.cert_type_id == 18"
            >
              <template v-if="record.details && record.details.length">
                <span v-for="(detail, index) in record.details" :key="index">
                  {{ detail.student ? detail.student.phone : '' }} <br />
                </span>
              </template>
              <template v-else-if="record.student">
                {{ record.student.phone }}
              </template>
            </td>
            <td class="ts-whitespace-nowrap" v-if="record.cert_type_id == 21">
              <template v-if="record.student_top_details && record.student_top_details.length">
                <span
                  v-for="(
                    student_top_detail, index
                  ) in record.student_top_details"
                  :key="index"
                >
                  {{ student_top_detail.student ? student_top_detail.student.phone : '' }} <br />
                </span>
              </template>
              <template v-else-if="record.student">
                {{ record.student.phone }}
              </template>
            </td>
            <td class="ts-whitespace-nowrap">
              {{
                record.certificate_type ? record.certificate_type.cert_type : ''
              }}
            </td>
            <td class="ts-text-center ts-whitespace-nowrap">
              {{ record.academic_year ? record.academic_year.ac_year : '' }}
            </td>
            <td class="ts-whitespace-nowrap" v-if="record.cert_type_id == 21">
              <template v-if="record.student_top_details && record.student_top_details.length">
                <span
                  v-for="(
                    student_top_detail, index
                  ) in record.student_top_details"
                  :key="index"
                >
                  {{ student_top_detail.student && student_top_detail.student.sub_program ? student_top_detail.student.sub_program.acps_name_foreign : '' }} <br />
                </span>
              </template>
              <template v-else>
                {{ record.sub_program ? record.sub_program.acps_name_foreign : '' }}
              </template>
            </td>
            <td class="ts-whitespace-nowrap" v-if="record.cert_type_id != 21">
              {{
                record.sub_program ? record.sub_program.acps_name_foreign : ''
              }}
            </td>
            <td class="ts-text-center w-whitespace-nowrap">
              {{
                record.created_by
                  ? record.created_by.employee
                    ? record.created_by.employee.name_en
                    : record.created_by.loginname
                  : ''
              }}
            </td>
            <td class="ts-text-center w-whitespace-nowrap">
              {{ record.printed_date }}
            </td>
            <td class="text-center ts-whitespace-nowrap">
              <!-- v-if="!record.is_printed" -->
              <a
                href="#"
                v-tooltip="$t('pdf')"
                class="text-danger"
                @click.prevent="print(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end ts-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('filter')"
      :closable="false"
      :visible="visible"
      :zIndex="1020"
      @close="() => (visible = false)"
      width="300px"
    >
      <div class="mb-3">
        <label class="form-col-label control-label">{{
          $t('appreciation.branch')
        }}</label>
        <ts-branch-filter @filter="value => (branch_id = value)" />
      </div>
    </a-drawer>
    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('appreciation.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="fetchData"
      :zIndex="1020"
      :footer="null"
      width="1080px"
    >
      <from-action @cancel="() => (showForm = false)" @fetchData="fetchData" />
    </a-modal>
    <a-modal :title="$t('pdf')" width="70%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import FromAction from './form.vue'
import { Errors } from 'form-backend-validation'
export default {
  name: 'appreciation',
  components: {
    FromAction
  },
  data () {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      src: '',
      showForm: false,
      show_pdf: false,
      visible: false,
      branch_id: [],
      certificate_types: []
    }
  },
  computed: {
    ...mapState('appreciation', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.appreciation.search
      },
      set (newValue) {
        this.$store.commit('appreciation/SET_SEARCH', newValue)
        this.$store.commit('appreciation/RESET_CURRENT_PAGE')
      }
    },
    cert_type_id: {
      get () {
        return this.$store.state.appreciation.cert_type_id
      },
      set (newValue) {
        this.$store.commit('appreciation/SET_CERT_TYPE_ID', newValue)
      }
    },
    columns () {
      return [
        {
          name: this.$t('appreciation.branch'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('appreciation.certificateNumber'),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t('appreciation.studentName'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('appreciation.sex'),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t('appreciation.phone'),
          style: 'white-space: nowrap;text-align:right;'
        },
        {
          name: this.$t('appreciation.certificateType'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('appreciation.academicYear'),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t('appreciation.subProgram'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('appreciation.printedBy'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('appreciation.printedDate'),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 5%;'
        }
      ]
    }
  },
  methods: {
    ...mapActions('appreciation', ['getCertificateAppreciation']),
    async fetchData (attributes) {
      this.loading = true
      await this.getCertificateAppreciation().then(response => {
        this.certificate_types = response.data
      })
      this.$store
        .dispatch('appreciation/fetch', {
          ...attributes,
          branch_id: this.branch_id
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew () {
      this.showForm = true
    },
    print (record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('appreciation/printPdf', record.print_id)
        .then(response => {
          this.src = response.url
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
    cert_type_id: debounce(function (cert_type_id) {
      this.fetchData({
        cert_type_id,
        search: this.search,
        branch_id: this.branch_id
      })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('appreciation/RESET_STATE')
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
